<div class="cell-button-generic-container">
  <a *ngIf="buttonStyle === 'link'" class="text-link--color-brand" (click)="click()">
    {{ params.key | translate }}
  </a>
</div>
